export default function Banners({ title, subtitle, className, imgSrc }) {
  return (
    <section className="relative">
      <div
        className={`sm:flex hidden items-center bg-blend-darken bg-right bg-cover mt-20 ${className}`}
      >
        <div className="px-5 md:px-10 md:w-10/12 mx-auto  flex flex-col  justify-center lg:gap-6  md:gap-5 gap-3 text-white ">
          <h3
            className="font-gilroy"
            dangerouslySetInnerHTML={{ __html: title }}
          />
          <p
            className="font-poppins font-light"
            dangerouslySetInnerHTML={{ __html: subtitle }}
          />
        </div>
      </div>

      {/* Mobile View */}
      <div className="sm:hidden block absolute bottom-7 overflow-hidden w-full">
        <div className="top-0 px-5 md:px-10 md:w-10/12 mx-auto  flex flex-col  justify-center lg:gap-6 md:gap-5 gap-2 text-white ">
          <h3
            className="font-gilroy text-center"
            dangerouslySetInnerHTML={{ __html: title }}
          />
          <p
            className="font-poppins font-light text-center"
            dangerouslySetInnerHTML={{ __html: subtitle }}
          />
        </div>
      </div>
      {imgSrc ? (
        <div className="sm:hidden block -z-[1]">
          <img
            className="h-full w-full object-cover"
            src={imgSrc}
            alt="mobile view mockup"
          />
        </div>
      ) : (
        ''
      )}
    </section>
  );
}
